import { useState } from 'react';
import { policySystemMessages } from '../content/policySystemMessages';
import { usePolicySystemStatus } from '../context/PolicySystemStatusProvider';

type PolicySystemBannerProps = {
  className?: string;
};

/**
 * Global banner when the policy system is degraded or unavailable.
 */
export default function PolicySystemBanner({ className = '' }: PolicySystemBannerProps) {
  const { showBanner, incidentRef } = usePolicySystemStatus();
  const [dismissed, setDismissed] = useState(false);

  if (!showBanner || dismissed) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className={`bg-amber-50 border-b border-amber-200 px-[16px] md:px-[32px] py-[12px] w-full ${className}`}
    >
      <div className="max-w-container-desktop mx-auto flex flex-col gap-[8px] md:flex-row md:items-start md:justify-between md:gap-[16px]">
        <p className="font-body font-regular text-sm leading-sm text-amber-950 m-0">
          {policySystemMessages.banner}
          {incidentRef ? (
            <span className="block mt-1 text-amber-900/80">Incident reference: {incidentRef}</span>
          ) : null}
        </p>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className="shrink-0 font-body font-semibold text-sm text-amber-900 underline self-start"
          aria-label="Dismiss policy system notice for this session"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
